import { styled } from '@uhg-abyss/web/tools/styled';

export const ReferralBannerBoxBanner = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  padding: '8px 8px 8px 12px',
  borderTop: '1px solid $core.color.brand.60',
  borderRight: '1px solid $core.color.brand.60',
  borderBottom: '1px solid $core.color.brand.60',
  borderLeft: '4px solid $core.color.brand.60',
  width: '348px',
  height: 'auto',
  columnGap: '4px',
  alignSelf: 'stretch',
  borderRadius: '4px',
  backgroundColor: ' $core.color.brand.5',
});

export const ExternalLinkIcon = styled('div', {
  height: '24px',
  width: '100%',
  alignItems: 'flex-end',
  alignContent: 'center',
  alignSelf: 'stretch',
  paddingLeft: '4px',
});

export const ContactMyPCP = styled('div', {
  whiteSpace: 'nowrap',
});

export const ReferralBannerTextContainer = styled('div', {
  width: '299px',
  height: '43px',
  gap: '4px',
  size: '14px',
  fontWeight: '700',
  color: '#323333',
});

export const ReferralBannerContactPCP = styled('button', {
  marginLeft: '14px',
  cursor: 'pointer',
  display: 'flex',
  width: '123px',
  color: '$core.color.brand.60',
  lineHeight: '18px',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  fontWeight: '600',
  alignItems: 'center',
  '@media (max-width: 464px)': {
    fontSize: '12.64px',
    lineHeight: '16px',
  },
  '@media (max-width: 744px)': {
    marginLeft: '0px',
  },
});
